import { Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import {
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogMedia,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function NpsSuccessAlert() {
	return (
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogMedia>
					<CheckCircle2 className="text-emerald-500" />
				</AlertDialogMedia>
				<AlertDialogTitle>Avaliação enviada com sucesso</AlertDialogTitle>
				<AlertDialogDescription>
					O feedback foi recebido e sua avaliação foi registrada no sistema.
				</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter className="sm:justify-center">
				<AlertDialogAction asChild className="w-full">
					<Link to="/">Voltar para o início</Link>
				</AlertDialogAction>
			</AlertDialogFooter>
		</AlertDialogContent>
	);
}
